import * as React from 'react';
import { useAuth } from "react-oidc-context";
import 'boxicons/css/boxicons.min.css';
import './style.scss';
import { useDispatch, useSelector } from 'react-redux';
import { AppDispatch, RootState } from '../../store';
import { fetchMarketDates } from '../../reducers/lookupSlice';
import { toggleTheme } from '../../reducers/themeSlice';
import { MenuBar } from '../../components/menu-bar';
import { SymbolSearchComponent } from '../../components/symbol-search';
import { GlobalLoader } from '../../components/global-loader';


interface ComponentProps {
	children: React.ReactNode
}

export const BaseContainer: React.FC<ComponentProps> = ({ children }) => {
    const dispatch = useDispatch<AppDispatch>();
    const auth = useAuth();
    const { marketDates, loading: lookupsLoading } = useSelector((state: RootState) => state.lookups);
    const { loading: positionsLoading } = useSelector((state: RootState) => state.alpaca);
    const { loading: symbolsLoading } = useSelector((state: RootState) => state.symbols);
    const { mode } = useSelector((state: RootState) => state.theme);
    const isApiLoading = lookupsLoading || positionsLoading || symbolsLoading;

    React.useEffect(() => {
        dispatch(fetchMarketDates());
        // Initialize theme on mount
        const savedTheme = localStorage.getItem('theme') || 'light';
        document.documentElement.setAttribute('data-theme', savedTheme);
    }, [dispatch]);

    const handleThemeToggle = () => {
        dispatch(toggleTheme());
    };
    /* const signOutRedirect = () => {
        const clientId = config.authConfig.client_id;
        const logoutUri = `${config.authConfig.redirect_uri}`;
        const cognitoDomain = config.authConfig.cognito_domain;

        window.location.href = `${cognitoDomain}/logout?client_id=${clientId}&logout_uri=${encodeURIComponent(logoutUri)}`;
    };
    const handleLogout = () => {
        auth.removeUser();
        auth.clearStaleState();
        signOutRedirect();
        //auth.signoutRedirect();
    }; */
    if (auth.isLoading) {
        return  (<div className='wrapper'>
            <div id="header">
                <div className='left'>
                    <a href="/" className='logo'>
                        <i className='bx bx-candles'></i>
                    </a>
                    <div className='title'>Sameer Portfolio</div>
                    <div className='clear' />
                </div>
                <div className='clear' />
            </div>
            <div id="content">
                <div className="message">Loading...</div>
            </div>
        </div>)
    }

    /*if (auth.error) {
        return (<div className='wrapper'>
            <div id="header">
                <div className='left'>
                    <a href="/" className='logo'>
                        <i className='bx bx-candles'></i>
                    </a>
                    <div className='title'>Sameer Portfolio</div>
                    <div className='clear' />
                </div>
                <div className='clear' />
            </div>
            <div id="content">
                <div className="message">Encountering error... {auth.error.message}</div>
            </div>
        </div>)
    }*/

    if (auth.isAuthenticated) {
        const groups = (auth.user?.profile?.['cognito:groups'] || []) as Array<string>;
        if (groups.find(g => g === 'app.watchlist.ui.user') && marketDates.length) {
            return (
                <div className='wrapper'>
                    <div id="header">
                        <div className='left'>
                            <a href="/" className='logo'>
                                <i className='bx bx-candles'></i>
                            </a>
                            <div className='title'>Sameer Portfolio</div>
                            <div className='clear' />
                        </div>
                        <SymbolSearchComponent />
                        <div className="right">
                            <button className='theme-toggle' onClick={handleThemeToggle} title='Toggle dark mode'>
                                <i className={`bx ${mode === 'light' ? 'bx-moon' : 'bx-sun'}`}></i>
                            </button>
                            <a onClick={() => auth.removeUser()}>Sign out</a>
                        </div>
                        <div className='clear' />
                    </div>
                    <MenuBar />
                    <div id="content">
                        {children}
                    </div>
                    {isApiLoading && <GlobalLoader message='Fetching latest data...' />}
                </div>
            );
        } else {
            return (
                <div className='wrapper'>
                    <div id="header">
                        <div className='left'>
                            <a href="/" className='logo'>
                                <i className='bx bx-candles'></i>
                            </a>
                            <div className='title'>Sameer Portfolio</div>
                            <div className='clear' />
                        </div>
                        <SymbolSearchComponent />
                        <div className="right">
                            <button className='theme-toggle' onClick={handleThemeToggle} title='Toggle dark mode'>
                                <i className={`bx ${mode === 'light' ? 'bx-moon' : 'bx-sun'}`}></i>
                            </button>
                            <a onClick={() => auth.removeUser()}>Sign out</a>
                        </div>
                        <div className='clear' />
                    </div>
                    <MenuBar />
                    <div id="content">
                        <div className="message">Sorry! You do not have permission to view this page. Please contact the administrator </div>
                    </div>
                    {isApiLoading && <GlobalLoader message='Fetching latest data...' />}
                </div>
            );
        }
    } else {
        auth.signinRedirect();
    }
};